module.exports = __webpack_public_path__ + "static/img/Immunology.900c89c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/divisionIcons/Immunology.svg
// module id = iva/
// module chunks = 26